"use strict";
var router_1 = require('@angular/router');
var sequencer_page_1 = require('./containers/sequencer-page');
exports.APP_ROUTER_PROVIDERS = [
    router_1.provideRouter([
        { path: '', component: sequencer_page_1.SequencerPage },
    ]),
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLnJvdXRlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImFwcC5yb3V0ZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLHVCQUdPLGlCQUFpQixDQUFDLENBQUE7QUFFekIsK0JBQThCLDZCQUE2QixDQUFDLENBQUE7QUFFL0MsNEJBQW9CLEdBQUc7SUFDbEMsc0JBQWEsQ0FBQztRQUNaLEVBQUUsSUFBSSxFQUFFLEVBQUUsRUFBRSxTQUFTLEVBQUUsOEJBQWEsRUFBRTtLQUN2QyxDQUFDO0NBQ0gsQ0FBQyJ9


/*****************
 ** WEBPACK FOOTER
 ** ./src/app.routes.ts
 ** module id = 956
 ** module chunks = 1
 **/